import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FullUserBoundary } from '@ui/general';
import React from 'react';
import { useAction } from '@hooks';

import { Button, ButtonProps } from 'antd';
import { coreActions, DataSecurityApplicationStatus } from '@sonar-software/sonar-core';

export interface ApproveApplicationButtonProps {
	applicationId: number;
	size?: ButtonProps['size'];
}

export const ApproveApplicationButton: React.FC<ApproveApplicationButtonProps> = ({ applicationId, size }) => {
	const patch = useAction(coreActions.requestPatchCoreDataSecurityApplicationsById);

	return (
		<FullUserBoundary>
			<Button
				className='approve-application-button'
				onClick={ () => patch({
					applicationId,
					status: DataSecurityApplicationStatus.Added
				}) }
				size={ size }
				type='primary'>
				{ COPY_SPECIFIC.APPROVE }
			</Button>
		</FullUserBoundary>
	);
};
